import { useEffect } from "react";

import Typography from "@mui/material/Typography";

const HeaderText = ({ text, sx = {} }) => {
  let allSx = {
    mt: 1,
    mb: 1,
    fontFamily: "arial",
    fontWeight: "700",
    color: "#696969",
  };

  useEffect(() => {}, []);

  return (
    <Typography variant="h6" component="h2" sx={allSx}>
      {text}
    </Typography>
  );
};

export default HeaderText;
